import { Base } from './base.model';

export class Faq extends Base {
  public page: string;
  public question: string;
  public answer: string;
  public order: string;
}
